import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';

class RelatedFMISRecord extends Component {

  //TODO: Duplicated with WFMI
  getDateString = (value) =>
  {
  return (value) ? moment(new Date(value)).format("MM/DD/YYYY h:mm A") : "";
  }

  getYesNo = (value) =>
  {
  return (value && (value === 1 || value === "1")) ? "Yes" : "No";
  }

  render()
  {
    const tableFields = [
      { label: "Record Number", key: "RecordNumber" },
      { label: "Unit Identifier", key: "UnitIdentifier" },
      { label: "Org Code", key: "OrgCode" },
      { label: "Org Name", key: "OrgName" },
      { label: "Unique Fire ID", key: "UniqueFireId" },
      { label: "Incident Name", key: "IncidentName" },
      { label: "Fire Code", key: "FireCode" },
      { label: "Report Status", key: "ReportStatus" },
      { label: "Fiscal Year", key: "FiscalYear" },
      { label: "Calendar Year", key: "CalendarYear" },
      { label: "Region", key: "Region" },
      { label: "Incident Kind", key: "IncidentKind" },
      { label: "Incident Category", key: "IncidentCategory" },
      { label: "Sub Category", key: "SubCategory" },
      { label: "Fire Cause", key: "FireCause" },
      { label: "Discovery Date", key: "DiscoveryDateTime" },
      { label: "Latitude", key: "Latitude" },
      { label: "Longitude", key: "Longitude" },
      { label: "Landowner Kind", key: "LandownerKind" },
      { label: "Landowner Category", key: "LandownerCategory" },
      { label: "Init Attack Date", key: "InitAttackDateTime" },
      { label: "Fire Containment Date", key: "FireContainDateTime" },
      { label: "Control Date", key: "ControlDateTime" },
      { label: "Out Date", key: "OutDate" },
      { label: "FWS Acres", key: "FWSAcres" },
      { label: "Total Acres", key: "TotalAcres" },
      { label: "Multiple Objective Acres", key: "MultipleObjectiveAcres" },
      { label: "Narrative", key: "Narrative" },
    ];

    // Helper function to chunk array into pairs
    const chunkArray = (arr, size) => {
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    };

    return (
      <Paper elevation={3}>
      <Table size="small">
        <TableBody>
          {chunkArray(tableFields, 2).map((rowPair, idx) => (
            <TableRow key={idx}>
              {rowPair.map(({ label, key }) => (
                <React.Fragment key={key}>
                  <TableCell style={{ fontWeight: "bold" }}>{label}:</TableCell>
                  <TableCell>{this.props.record[key]}</TableCell>
                </React.Fragment>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </Paper>
  )
  }
}

export default RelatedFMISRecord;
